import { CONTAINER_APP_STATUS_ENUM } from '@tenant/utility/constants/enum';
/**
 *
 * @param {*} status: int status
 * @returns boolean
 */
export default function (status) {
  return status === CONTAINER_APP_STATUS_ENUM['Stopped'];
}
